import {Usuario} from "./usuario";
import {Versao} from "../shared/versao";
import { UsuarioLogadoConfig } from './usuario-logado-config';

export class UsuarioLogado {

    usuario: Usuario;
    situacao: string;
    ip: string;
    versao: Versao;
    chave: string;
    dtExpiraChave: string;
    usuarioConfig: UsuarioLogadoConfig;


    constructor(usuario?: Usuario,
                situacao?: string,
                ip?: string,
                versao?: Versao,
                chave?: string,
                dtExpiraChave?: string,
                usuarioConfig : UsuarioLogadoConfig = new UsuarioLogadoConfig()) {
        this.usuario = usuario;
        this.situacao = situacao;
        this.ip = ip;
        this.versao = versao;
        this.chave = chave;
        this.dtExpiraChave = dtExpiraChave;
        this.usuarioConfig = usuarioConfig;
    }

    isMostraSelectMercados() {
        return this.usuarioConfig.mostraSelectMercados === true;
    }

    isAtivo() {
        return this.situacao === 'A';
    }

    isAdmin() {
        return this.usuario.tipo === 'AD';
    }

    isMercado() {
        return this.usuario.tipo === 'ME';
    }

    isFilial() {
        return this.usuario.tipo === 'FI';
    }

    isFornecedor() {
        return this.usuario.tipo === 'FO';
    }

    isVendedor() {
        return this.usuario.tipo === 'VE';
    }

    isAgrupaCotacao(): boolean {
        return this.usuario.agrupaCotacao == 'S';
    }

    isAgrupaFornecedor(): boolean {
        return this.usuario.agrupafornecedor == 'S';
    }

    isAgrupaCotacaoAndIsGrupoAdmin(): boolean {
        return this.isAgrupaCotacao() && (this.isAdmin() || this.isMercado() || this.isFilial());
    }
}
